
export function base64ToFile(base64Image: string, contentType: string|undefined): Blob {
  let data=undefined;
  let type=undefined;
  if(base64Image.indexOf(',')>-1){
    const split = base64Image.split(',');
    type = split[0].replace('data:', '').replace(';base64', '');
    data=split[1];
  }
  
  else{
    type=contentType?.replace('data:', '').replace(';base64', '');;
    data=base64Image;
  }  
  const byteString = window.atob(data);
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i += 1) {
    ia[i] = byteString.charCodeAt(i);
  }
  return new Blob([ab], {type});
}

export const blobToBase64 = (blob: Blob) => new Promise((resolve, reject) => {
  const reader = new FileReader;
  reader.onerror = reject;
  reader.onload = () => {
      resolve(reader.result);
  };
  reader.readAsDataURL(blob);
});

export function base64ToArrayBuffer(imageBase64: string) {
  imageBase64 = imageBase64.replace(/^data\:([^\;]+)\;base64,/gmi, '');
  const binaryString = window.atob(imageBase64);
  const len = binaryString.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes.buffer;
}

/*
export function base64ToBlob(base64String: string, contentType: string = ''): Promise<Blob> {
  return fetch(`data:${contentType};base64,${base64String}`)
    .then(response => response.blob());
}
*/

export function base64ToBlob(base64String: string, contentType: string = ''): Promise<Blob> {
  return new Promise((resolve, reject) => {
    try {
      // Strip data URL prefix if present (e.g. "data:text/plain;base64,")
      const sanitized = base64String.includes(',')
        ? base64String.split(',')[1]
        : base64String;

      // Strip whitespace/newlines servers sometimes inject
      const clean = sanitized.replace(/\s/g, '');

      const byteCharacters = atob(clean);
      const byteNumbers = new Array(byteCharacters.length);

      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: contentType });
      resolve(blob);
    } catch (e) {
      reject(new Error(`base64ToBlob failed: ${e instanceof Error ? e.message : String(e)}`));
    }
  });
}

